import { render, staticRenderFns } from "./minor-linking.vue?vue&type=template&id=5f212778&scoped=true&"
import script from "./minor-linking.vue?vue&type=script&lang=js&"
export * from "./minor-linking.vue?vue&type=script&lang=js&"
import style0 from "./minor-linking.vue?vue&type=style&index=0&id=5f212778&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f212778",
  null
  
)

export default component.exports